// extracted by mini-css-extract-plugin
module.exports = {"cover":"_22549b1d","noPicture":"_78ea34bd","details":"_87f2da52","tabsWrapper":"_b3603907","top":"_39818b7b","headshot":"_7899bb98","follow":"_8d85bd21","profileCover":"_5d61ab76"};